// import { Player } from "@lottiefiles/react-lottie-player";
import { Spinner } from "react-bootstrap";

export default function InPayement({text}) {
    // states


    // comportements
    // const handlerefresh = () => {
    //     window.location.reload();
    // }


    // affichage
    return (
        <div className="row">
        {/* <div className="row" style={{ height: "88vh" }}> */}
            <div className="col-md-12 mb-3 text-center">
                <p className='text-center text-dark' style={{ fontSize: 20 }}><Spinner
                    as="span"
                    animation="border"
                    size="lg"
                    role="status"
                    aria-hidden="true"
                    style={{ display: "block", marginLeft: 'auto', marginRight: 'auto' }}
                /> {text}</p>
                {/* <button onClick={handlerefresh} className="btn btn-primary">
                    <Clock style={{marginRight: 8}}/> Refresh 
                </button> */}
            </div>
            <div className="col-md-12">
                <img src="/assets/imgs/transaction.jpg" alt="" style={{ width: "40%", display: "block", marginLeft: "auto", marginRight: "auto" }} />
                {/* <Player
                    autoplay
                    loop
                    src="/assets/imgs/network_error.json"
                    style={{ height: '296px', width: '296px',  }}
                    >
                </Player> */}
            </div>
        </div>
    )
}